const OuterCircleStroke = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    fill="none"
    viewBox="0 0 28 28"
    className={'outer'}
  >
    <path stroke="#999" d="M1 14C1 6.82 6.82 1 14 1"></path>
    <path
      stroke="#999"
      d="M1 14c0 7.18 5.82 13 13 13s13-5.82 13-13S21.18 1 14 1"
    ></path>
  </svg>
);

export default OuterCircleStroke;
